import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import DataGrid from '../../components/common/dataGrid/dataGrid';
import ButtonWithSearch from '../../components/common/buttonWithSearch';
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import {
  generateColumnMetadata,
  orderObj,
  dateFormat,
  Feature,
  convertToNameLabel,
} from "../../utils/utils";
import { DonationTableColumns, donorFormRender } from "../../utils/serviceData";
import ProfileView from '../../components/common/profileView';
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import InputIterator from '../../components/common/inputIterator';
import AddButtonSection from '../../components/common/AddButtonSection';
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { SORT_ORDER } from "../../constants/sortOrder";
import { useParams } from "react-router-dom";
import { Button } from "primereact/button";
import moment from "moment";
import InputPrimaryComponents from '../../components/common/inputPrimaryComponents';
import "../../assets/styles/donationlist.scss";
import AddImageSection from '../../components/common/AddImageSection';


export default function DonationList() {
  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    reset,
    setValue,
  } = useForm({});
  const menuLeft = useRef(null);
  const { id } = useParams();
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [donorLoading, setDonorLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [editDonorVisible, setEditDonorVisible] = useState(false);
  const [donorVisible, setDonorVisible] = useState(false);
  const [donorDetails, setDonorDetails] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [donorId, setDonorId] = useState(null);
  const [uploadedImg, setUploadedImg] = useState({});
  const [formRender, setFormRender] = useState(donorFormRender);
  const [selectedDonorRow, setSelectedDonorRow] = useState({});
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "user_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: {
      donation_amount: "",
    },
  });

  const fields = [
    "donor_name",
    "first_name",
    "last_name",
    "email",
    "address",
    "city",
    "district",
    "state",
    "pincode",
    "phone_no",
    "profile_picture"
  ];

  function onPageChange(event) {
    const updatedNav = {
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    };
    setNavigator(updatedNav);
    fetchDonation(updatedNav);
  }

  const addDonation = async (data) => {
    if (loader) return;
    setLoader(true);
    const addAmount = {
      donor_id: id,
      donation_amount: data?.amount,
      donation_date: dateFormat(data?.date),
    };
    const editAmount = {
      donation_records_id: donorId,
      donation_amount: data?.amount,
      donation_date: dateFormat(data?.date),

    }
    let headers = {
      "Content-Type": "application/json",
    };
    await commonPostApi(isEdit ? API_ENDPOINTS.EDIT_DONATION : API_ENDPOINTS.ADD_DONATION, isEdit ? editAmount : addAmount, {
      headers,
    })
      .then((data) => {
        if (data?.data?.success) {
          showToast(TOAST_TYPE.SUCCESS, isEdit ? FEATURE_MSG.DONOR.DONATION_UPDATED : FEATURE_MSG.DONOR.DONATION_ADDED);
          setDonorVisible(false);
          init(navigator);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const donorbtn = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: handleSubmit(addDonation),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setDonorVisible(false);
      },
    },
  ];

  const onEdit = async (data) => {
    if (loader) return;
    setLoader(true);
    let headers = {};
    let editDonor = {
      ...data,
      donor_id: id,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),
    }
    let finaldata = editDonor;
    if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
      finaldata = new FormData();
      finaldata.append("profile_picture", uploadedImg);
      finaldata.append("_payload", JSON.stringify(editDonor));
      headers = { "Content-Type": "multipart/form-data" };
    }
    else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(
      API_ENDPOINTS.EDIT_DONOR_DETAILS,
      finaldata,
      {
        headers,
      }
    )
      .then((data) => {
        if (data?.message) {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.DONOR.UPDATED);
          setEditDonorVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const EditDonorbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: loader || (Object.keys(dirtyFields).length === 0 && !uploadedImg),
      onClick: handleSubmit(onEdit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setEditDonorVisible(false);
        setUploadedImg(donorDetails.finalData.imgUrl);
      },
    },
  ];

  const fetchDonation = async (nav) => {
    setLoading(true);
    let query = {
      page: nav?.page,
      limit: nav?.rows,
      sortFields: nav?.sortFields,
      searchCriteria: nav?.searchCriteria,
      donor_id: id,
    };
    await commonPostApi(API_ENDPOINTS.GET_DONATION_BY_ID, query)
      .then((donation) => {
        const donationDetails = donation?.data?.data?.map((donation) => ({
          ...donation,
          donation_amount: Number(donation?.donation_amount) || 0,
          created_at: donation?.created_at
            ? moment(donation?.created_at).format("YYYY-MM-DD")
            : "",
        }));

        setNavigator((prev) => ({
          ...prev,
          totalRecords: donation?.data?.total,
          page: donation?.data?.currentPage,
        }));
        setColumns(
          orderObj(
            ["donation_code", "created_at", "donation_amount"],
            DonationTableColumns,
            generateColumnMetadata({
              data: donationDetails,
              alias: {
                donor_id: "donation",
                donation_code: "donation code",
                created_at: "date",
                donation_amount: "amount",
              },
              defaultColumnsArr: DonationTableColumns,
            })
          )
        );
        setValues(donationDetails);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const init = async (navigator) => {
    setLoading(true);
    let query = {
      page: navigator?.page,
      limit: navigator?.rows,
      sortFields: navigator?.sortFields,
      searchCriteria: navigator?.searchCriteria,
      donor_id: id,
    };

    Promise.all([
      commonPostApi(API_ENDPOINTS.GET_DONOR_BY_ID, {
        donor_id: id,
      }),
      await commonPostApi(API_ENDPOINTS.GET_DONATION_BY_ID, query),
    ])
      .then(([donor, donation]) => {
        const userData = donor?.data?.data;
        fields.forEach((fieldName) => {
          setValue(fieldName, userData?.[fieldName]);
        });
        const finalList = {};
        ["email", "phone_no", "address"].forEach((item) => {
          const nameMap = { phone_no: "Phone Number", email: "Email", address: "Address" };
          finalList[item] = { name: nameMap[item] || item, value: userData[item] };
        });
        let finalData = convertToNameLabel(finalList, [
          "donor_name",
          "first_name",
          "last_name",
          "city",
          "district",
          "state",
          "phone_no",
          "profile_picture"
        ])

        finalList.name = userData["donor_name"];
        finalData.name = userData["donor_name"];
        finalData.imgUrl = userData?.profile_picture
          ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(userData?.donor_id)}`
          : null;
        setUploadedImg(finalData.imgUrl)
        finalData = Object.entries(finalData)
          .map(([label, value]) => {
            if (typeof value === "object" && value !== null) {
              return { [label]: value.value || "" };
            }
            return { [label]: value };
          })
          .reduce((acc, item) => ({ ...acc, ...item }), {});
        setDonorDetails({ finalData, originalData: userData });
        const donationDetails = donation?.data?.data?.map((donation) => ({
          ...donation,
          donation_amount: Number(donation?.donation_amount) || 0,
          created_at: donation?.created_at
            ? moment(donation?.created_at).format("YYYY-MM-DD")
            : "",
        }));

        setNavigator((prev) => ({
          ...prev,
          totalRecords: donation?.data?.total,
          page: donation?.data?.currentPage,
        }));
        setColumns(
          orderObj(
            ["donation_code", "created_at", "donation_amount"],
            DonationTableColumns,
            generateColumnMetadata({
              data: donationDetails,
              alias: {
                donor_id: "donation",
                donation_code: "donation code",
                created_at: "date",
                donation_amount: "amount",
              },
              defaultColumnsArr: DonationTableColumns
            })
          )
        );
        setValues(donationDetails);
        setDonorLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onSortClick = (event) => {
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    const updatedNav = {
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    };
    setNavigator(updatedNav);
    fetchDonation(updatedNav);
  };

  const donorEdit = [
    {
      type: "primarySuccessButton",
      label: "Edit",
      class: "card-button-edit",
      onClick: () => {
        setSelectedDonorRow(donorDetails.originalData);
        setEditDonorVisible(true);
      },
    },
  ];

  const button = [
    {
      type: "primarySuccessButton",
      label: "Add Donation",
      icon: "pi pi-plus",
      class: "mt-2 w-full md:flex md:pr-4 pr-3",
      onClick: () => {
        setDonorVisible(true);
        reset();
        setIsEdit(false)
        setValue("donor_name", donorDetails?.finalData?.name);
      },
    },
  ];

  const itemRenderer = (item, prop) => (
    <div className="p-menuitem-content">
      {item.label === "Edit Donation" &&
        Feature?.featureVerify(Feature.listOfFeature.userAddRole) && (
          <Button
            className="card-button-assign-role"
            label="Edit Donation"
            onClick={() => {
              const rowData = prop?.props?.itemProp;
              reset();
              setDonorVisible(true);
              setIsEdit(true);
              setDonorId(rowData?.donation_records_id);
              setValue("donor_name", donorDetails?.finalData?.name);
              setValue(
                "date",
                rowData?.created_at
                  ? moment(rowData?.created_at, "YYYY-MM-DD").toDate()
                  : null
              );
              setValue("amount", rowData?.donation_amount);
            }}
          />
        )}
    </div>
  );

  useEffect(() => {
    init(navigator);
    setFormRender((form) => {
      const filteredForm = form.filter((item) => item?.type !== "password");
      return filteredForm;
    });
  }, []);
  useEffect(() => {
    if (!editDonorVisible) return;
    fields.forEach((fieldName) => {
      setValue(fieldName, selectedDonorRow?.[fieldName]);
    });
  }, [selectedDonorRow, editDonorVisible]);


  const handleSeachChange = (value) => {
    const updatedNav = {
      ...navigator,
      searchCriteria: {
        ...navigator?.searchCriteria,
        donation_amount: value,
      },
    };
    setNavigator(updatedNav);
    fetchDonation(updatedNav);
  }

  return (
    <div className="donationlist-container container">
      <ProfileView
        profile={donorDetails?.finalData}
        button={
          Feature?.featureVerify(Feature?.listOfFeature?.campEdit) && donorEdit
        }
        loading={donorLoading}
        parentClass={"ml-auto"}
      />

      <DataGrid
        header={
          <ButtonWithSearch
            buttons={button}
            searchHeaderLable={"Donation List"}
            searchPlaceHolder={"Search Donations"}
            isSearchEnabled={true}
            isCalenderEnabled={false}
            isButtonEnabledLeft={false}
            isButtonEnabledRight={Feature?.featureVerify(
              Feature.listOfFeature.campAdd
            )}
            loading={loading}
            styles={{ gridTemplateColumns: "1fr 400px" }}
            onChange={handleSeachChange}
          />
        }
        onSortClick={onSortClick}
        onPageChange={onPageChange}
        isPaginatorEnabled={true}
        navigator={navigator}
        column={columns}
        value={values}
        ref={menuLeft}
        loading={loading}
        sortable={true}
        optionsView={[
          {
            items: [
              {
                label: "Edit Donation",
                icon: "pi pi-pencil",
                template: itemRenderer,
              },
            ],
          },
        ]}
      />
      {donorVisible && (
        <PrimarySideBar
          visible={donorVisible}
          onHide={() => setDonorVisible(false)}
          header={<div className="sideBar-header">{isEdit ? "Edit" : "Add"} Donation Amount</div>}
        >
          <InputPrimaryComponents
            control={control}
            type="text"
            label="Donor Name"
            name="donor_name"
            searchIcon
            required
            disabled
          />

          <InputPrimaryComponents
            type="calendar"
            label="Date"
            name="date"
            rules={{
              required: "Date is required",
            }}
            required
            control={control}
            errors={errors}
          />
          <div className="">
            <InputPrimaryComponents
              type="currency"
              label="Amount"
              name="amount"
              rules={{
                required: "Amount is required",
                validate: {
                  minValue: (value) =>
                    parseInt(value, 10) > 0 || "Payment amount cannot be zero",
                },
              }}
              required
              control={control}
              errors={errors}
            />
          </div>
          <div className="pt-3">
            <AddButtonSection disabled={loading} buttons={donorbtn} />
          </div>
        </PrimarySideBar>
      )}

      {editDonorVisible && (
        <PrimarySideBar
          visible={editDonorVisible}
          onHide={() => {
            setEditDonorVisible(false)
            setUploadedImg(donorDetails.finalData.imgUrl);
          }}
          header={<div className="sideBar-header">Edit Donor</div>}
        >
          <AddImageSection showImg={uploadedImg} setImg={setUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
          />

          <div className="pt-3">
            <AddButtonSection buttons={EditDonorbuttons} />
          </div>
        </PrimarySideBar>
      )}
    </div>
  );
}
